import { ReactNode } from 'react';

import { Chip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Skeleton } from '@material-ui/lab';

import {
  FilterViewer,
  FilterViewerComponentProps,
} from '@spotify/confidence-core-react';

export interface FilterChipProps<T> extends FilterViewerComponentProps<T> {
  label: ReactNode;

  // If true, the chip will be displayed as a skeleton.
  loading?: boolean;
}

/**
 * A filter view component that displays a chip with a label and a delete icon.
 * Takes the same props as the FilterViewer component, plus a label prop.
 */
export const FilterChip = <T,>(props: FilterChipProps<T>) => {
  const { label, loading, ...rest } = props;

  if (loading) {
    return <ChipSkeleton />;
  }

  return (
    <FilterViewer {...rest}>
      {({ onRemove, onEdit }) => (
        <Chip
          label={label}
          onDelete={onRemove}
          onClick={onEdit}
          deleteIcon={<CloseIcon />}
        />
      )}
    </FilterViewer>
  );
};

function ChipSkeleton() {
  return (
    <Skeleton
      variant="rect"
      style={{ borderRadius: 99999 }}
      data-testid="filter-chip-skeleton"
    >
      <Chip label="Loading..." deleteIcon={<CloseIcon />} />
    </Skeleton>
  );
}
